export enum EAppService {
  AppStore = 'AppStore',
  GooglePlay = 'GooglePlay',
  RuStore = 'RuStore',
  AppGallery = 'AppGallery',
}
